import React from "react";
import { SpaceName } from "../types";

interface Props {
  pt?: SpaceName;
  pb?: SpaceName;
  pl?: SpaceName;
  pr?: SpaceName;
  ph?: SpaceName;
  pv?: SpaceName;
  p?: SpaceName;
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Spacing = (props: Props) => {
  var { pt, pb, pl, pr, ph, pv, p } = props;

  if (p) {
    pt = pb = pl = pr = p;
  }
  if (ph) {
    pl = pr = ph;
  }
  if (pv) {
    pt = pb = pv;
  }

  return (
    <div
      style={{
        paddingTop: pt && spacingMap(pt),
        paddingBottom: pb && spacingMap(pb),
        paddingLeft: pl && spacingMap(pl),
        paddingRight: pr && spacingMap(pr)
      }}
      className={props.className}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
};

const spacingMap = (name: SpaceName) => {
  switch (name) {
    case "7xs":
      return 1;
    case "6xs":
      return 2;
    case "5xs":
      return 4;
    case "4xs":
      return 5;
    case "3xs":
      return 8;
    case "2xs":
      return 10;
    case "xs":
      return 15;
    case "s":
      return 20;
    case "m":
      return 25;
    case "l":
      return 30;
    case "xl":
      return 35;
    case "2xl":
      return 40;
    case "3xl":
      return 45;
    case "4xl":
      return 50;
    case "5xl":
      return 60;
    case "6xl":
      return 70;
    case "7xl":
      return 80;
    case "8xl":
      return 90;
  }
};
